import React from 'react';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { Banner, BannerContent } from '@thrivetribe/mvf.ui.molecules.banner';
import { Button } from '@thrivetribe/mvf.ui.atoms.button';
import { ButtonArrow } from '@thrivetribe/mvf.assets.icons.button-arrow';
import 'swiper/css';
import 'swiper/css/autoplay';

interface Asset {
  file: {
    url: string;
  };
}

interface BannerType {
  id: string;
  title: string;
  body: string;
  ctaCopy: string;
  url: string;
  slug?: string;
  asset?: Asset;
  externalLink: boolean;
  campaign?: string;
  campaignContentType?: string;
  campaignTagType?: string;
  campaignTags: string[];
}

interface BannerInsertProps {
  content: BannerType;
}

const getInternalUrl = (content: BannerType) => {
  const initialValue = '';
  const campaignTagsQuery = content.campaignTags.reduce(
    (accumulator, currentValue) =>
      accumulator
        ? `${accumulator}&${content.campaignTagType}=${currentValue}`
        : `${content.campaignTagType}=${currentValue}`,
    initialValue
  );

  return `?campaign=${content.campaign}&contentType=${content.campaignContentType}&tagType=${content.campaignTagType}&${campaignTagsQuery}`;
};

const BannerInsert = ({ content }: BannerInsertProps) => {
  const contentUrl =
    !content.externalLink && content.campaign
      ? content.url + getInternalUrl(content)
      : content.url;
  return (
    <Banner
      href={contentUrl}
      style={
        content?.asset?.file?.url
          ? {
              backgroundImage: `url(${content.asset.file.url})`,
              backgroundPosition: 'bottom',
              backgroundSize: 'cover',
            }
          : {}
      }
    >
      <BannerContent>
        <h3>{content.title}</h3>
        <p>{content.body}</p>
        <Button
          variant="text"
          onClick={() => {
            window.location.href = contentUrl;
          }}
        >
          {content.ctaCopy} <ButtonArrow />
        </Button>
      </BannerContent>
    </Banner>
  );
};

interface BannerSliderProps {
  content: BannerType[];
}
export const BannerSlider = ({ content }: BannerSliderProps) => {
  const swiperSettingsProps: SwiperProps = {
    modules: [Pagination, Autoplay],
    pagination: { clickable: true, dynamicBullets: true },
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoplay: {
      delay: 6000,
    },
    breakpoints: {
      1200: {
        allowTouchMove: false,
      },
    },
  };

  if (content.length === 0) {
    return <></>;
  }

  if (content.length > 1) {
    return (
      <Swiper {...swiperSettingsProps}>
        {content.map((content) => (
          <SwiperSlide key={content.id}>
            <BannerInsert content={content} />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }

  return <BannerInsert content={content[0]} />;
};
